import "../styles.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import React from "react";

// ✅ IMPORT YOUR LOCAL BANNERS
import banner1 from "../../assets/banner1.jpeg";
import moti from "../../assets/moti.jpeg";
import mangalSutra from "../../assets/mangalSutra.png";

// ✅ BANNER DATA
export const bannerData = [
    { id: 1, url: banner1 },
    { id: 2, url: moti },
    { id: 3, url: mangalSutra }
];

// ✅ RESPONSIVE SETTINGS
const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    }
};

const Banner = () => {

    return (
        <div className="carousel-container">
            <Carousel
                responsive={responsive}
                swipeable={true}
                draggable={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                showDots={true}
                arrows={true}
            >
                {
                    bannerData.map((banner) => (
                        <img
                            key={banner.id}
                            src={banner.url}
                            alt="banner"
                            style={{
                                width: "100%",
                                height: "auto",
                                maxHeight: "583px",
                                objectFit: "contain",   // ✅ no crop
                                backgroundColor: "#fff"
                            }}
                        />
                    ))
                }
            </Carousel>
        </div>
    );
};

export default Banner;